<template>
    <div style="margin:0 10px;">
         <el-cascader size='small' :options="options" placeholder="请选择管理单位" @change="onChange" v-model="value" :props="{ label: 'name', value: 'id', children: 'children' }"></el-cascader>
    </div>
</template>
<script>
import {getMapCompanyList} from '@/api/map.js'
import {listToTree} from '@/api/asset.js'
export default {
    name:'unitSelector',
    data(){
        return{
            value:[],
            options: [
                {
                value: 'zhejiang',
                label: 'Zhejiang',
                children: [
                    {
                    value: 'hangzhou',
                    label: 'Hangzhou',
                    children: [
                        {
                        value: 'xihu',
                        label: 'West Lake',
                        },
                    ],
                    },
                ],
                },
                {
                value: 'jiangsu',
                label: 'Jiangsu',
                children: [
                    {
                    value: 'nanjing',
                    label: 'Nanjing',
                    children: [
                        {
                        value: 'zhonghuamen',
                        label: 'Zhong Hua Men',
                        },
                    ],
                    },
                ],
                },
            ],
        }
    },
    methods:{
        onChange(val,selectedOptions){
            this.$emit('unitChange',this.value)
        },
        getCompanyLists(){
            getMapCompanyList().then(res=>{
            let data=res.data;
            if(data.code==='000'){
                let resList=data.content.list;
                this.options=listToTree(resList);
            }else{
                console.log(data.desc)
            }
            })
        },
    },
    created(){
        this.getCompanyLists();
    }
}
</script>

